import { render, staticRenderFns } from "./SectionTabs.vue?vue&type=template&id=e1e9a73a&scoped=true&"
import script from "./SectionTabs.vue?vue&type=script&lang=js&"
export * from "./SectionTabs.vue?vue&type=script&lang=js&"
import style0 from "./SectionTabs.vue?vue&type=style&index=0&id=e1e9a73a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e9a73a",
  null
  
)

export default component.exports